import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ui-datepicker-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "ui-datepicker-title"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger ml-1"
}

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { computed, onMounted, ref, useSlots } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ui-datepicker',
  props: {
  /**
   * Обязательно ли поле
   */
  required: {
    type: Boolean,
    default: false,
  },
  /**
   * Включена ли валидация
   */
  isValid: {
    type: Boolean,
    default: false,
  },
  /**
   * Заблокировать поле
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * Плейсхолдер
   */
  placeholder: {
    type: String,
    default: "",
  },
  /**
   * Значение
   */
  modelValue: {
    type: Array<Date>,
  },
  /**
   * Параметры для валидации
   */
  params: {
    type: Object,
    default: null,
  },
  /**
   * Функция для валидации
   */
  validFunction: {
    type: Function,
    default: null,
  },
  /**
   * * Режим выбора диапазона
   */
  range: {
    type: Boolean,
  },
},
  emits: ["update:modelValue", "validation"],
  setup(__props, { emit }) {

const props = __props;



/**
 * События
 */


/**
 * Столы
 */
const slots = useSlots();
/**
 * Существуют ли слоты
 */
const hasSlot = (name: string) => {
  return !!slots[name];
};

/**
 * Внутреннее значение
 */
const innerValue = ref<Array<Date>>();

/**
 * Значение
 */
const value = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value) => {
    emit("update:modelValue", value);
    innerValue.value = value;
  },
});
/**
 * * Формат вывода даты
 */
const format = (value: Date | Array<Date>) => {
  if (value instanceof Array<Date> && value && value.length == 2) {
    let startDate = `${value[0].getDate()}.${value[0].getMonth()}.${value[0].getFullYear()}`;
    let endDate = `${value[1].getDate()}.${value[1].getMonth()}.${value[1].getFullYear()}`;
    return `${startDate} - ${endDate}`;
  } else if (value instanceof Date && value) {
    return `${value.getDate()}.${value.getMonth()}.${value.getFullYear()}`;
  }

  return "";
};

onMounted(async () => {
  innerValue.value = props.modelValue;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasSlot('title'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title"),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueDatePicker), {
      class: "ui-datepicker",
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      "auto-apply": "",
      range: __props.range,
      "enable-time-picker": false,
      locale: "ru",
      format: format
    }, null, 8, ["modelValue", "range"])
  ]))
}
}

})